import React from "react";
import { SOURCE_PROPS } from './source_const.jsx';
import Select from "../../../../common/Select.jsx";
import MapboxHelpTooltip from "../component/MapboxHelpTooltip.jsx";

const RasterTypeSetting = ({updateField, sourceField, index}) => {
    const raster = sourceField.raster || {};
    const {minzoom, maxzoom, tiles} = SOURCE_PROPS.raster
    return (
      <>
        <label className='col-xs-12 col-md-12'>
          {tiles.title}
          <MapboxHelpTooltip description={tiles.description} />
          <input
              type="text"
              className="form-control"
              data-index={index}
              value={raster.tiles || tiles.default}
              onChange={(e) => updateField(`sourceFields.${index}.raster.tiles`, e.target.value)}
          />
        </label>
        <label className='col-xs-6 col-md-6'>
          {minzoom.title}
          <MapboxHelpTooltip description={minzoom.description} />
          <Select
            value={raster.minzoom || minzoom.default}
            options={Array.from({length : raster.maxzoom || maxzoom.default}, (v,index) => ({value: index, label: index}))}
            onChange={(v) => updateField(`sourceFields.${index}.raster.minzoom`, parseInt(v) || minzoom.default)}
          />
        </label>
        <label className='col-xs-6 col-md-6'>
          {maxzoom.title}
          <MapboxHelpTooltip description={maxzoom.description} />
          <Select
            value={raster.maxzoom || maxzoom.default}
            options={Array.from({length : (maxzoom.default - (raster.minzoom || minzoom.default))}, (v,index) => ({value: maxzoom.max - index, label: maxzoom.max - index})).reverse()}
            onChange={(v) => updateField(`sourceFields.${index}.raster.maxzoom`, parseInt(v) || maxzoom.default)}
          />
        </label>
      </>
    )
}
export default RasterTypeSetting;